/*Product Slider and Thumbnails*/
jQuery_T4NT(document).ready(function($){
  $('.product-single__thumbnail-image').click(function() {
    $('.product-single__thumbnail-image').removeClass("active-thumb");
    var thumb_index = $(this).index();
    $('.pr_carousel').flickity( 'select', thumb_index );
    $('.product-single__thumbnail-image').eq(thumb_index).addClass("active-thumb");
  });
  $('.pr_carousel .flickity-button').click(function() {
    $('.product-single__thumbnail-image').removeClass("active-thumb");
    var flickity_index = $(this).parent().find(".is-selected").index();
    $('.product-single__thumbnail-image').eq(flickity_index).addClass("active-thumb");
  });
  $('.pr_carousel .flickity-page-dots').click(function() {
    $('.product-single__thumbnail-image').removeClass("active-thumb");
    var dot_index = $(this).find(".dot.is-selected").index();
    $('.product-single__thumbnail-image').eq(dot_index).addClass("active-thumb");
  });
  var default_index = $('.pr_carousel').find('.flickity-slider .is-selected').index();
  $('.product-single__thumbnail-image').eq(default_index).addClass('active-thumb');  
});

/*Sidebar filter*/
jQuery_T4NT(document).ready(function($){
   $('body').on('click', '.accordion li', function(){
     var filter_id = $(this).parents('.accordion').attr('id');
     localStorage.setItem('filter_id', filter_id);
     setTimeout(function(){  
           var ajp = localStorage.getItem('filter_id');
           var currentProductType = text();
           $(".blockid_products li").hide(); 
           $(".blockid_products").find('li[data-attr="'+ currentProductType +'"]').show();
           $('#'+ ajp).slideDown(300);
           $('#'+ ajp).prev().children(".plusminus").text('-');;
     },15000);
  });
     
  $('body').on('click', '.sub_types.active', function(e){
    e.preventDefault();
    if ($('.sub_sub_types').is(':visible')) {
      $(".sub_sub_types").slideUp(300);
      $(".sign").text('+');
    }else{
      $(".sub_sub_types").slideDown(300);
      $(".sign").text('-');
    }
  });
});

jQuery_T4NT(document).ready(function($){
  $('body').on('click', '.widget-title', function(){ 
    var currentProductType = text();
    $(".blockid_products li").hide(); 
    $(".blockid_products").find('li[data-attr="'+ currentProductType +'"]').show();
    if ($(this).next(".accordion").is(':visible')) {
      $(this).next(".accordion").slideUp(300);
      $(this).children(".plusminus").text('+');
    } else {
      $(this).next(".accordion").slideDown(300);
      $(this).children(".plusminus").text('-');
    }
  });
  
  $('body').on('click', '.result_clear a.clear_filter:first', function(){ 
    setTimeout(function() {
      newtitle();
    },700);
  });
  
  newtitle();

  /*Mega-Menu*/
  $(".menu_item-linklist").eq(0).show().addClass("active");
  $(".menu_item").eq(0).addClass("active");
  $(".menu_item a").mouseover(function(){
     var el = $(this).attr("data-child");
     $(".menu_item-container").find('div[data-parent!="'+ el +'"]').hide();
     $(".menu_item-container").find('div[data-parent!="'+ el +'"]').removeClass("active");
     $(".menu_item-container").find('div[data-parent="'+ el +'"]').show();
     $(".menu_item-container").find('div[data-parent="'+ el +'"]').addClass("active");
     var em = $(".menu_item-linklist.active").attr("data-parent");
     $(".menu_item-container").find('a[data-child="'+ em +'"]').parent().addClass("active");
     $(".menu_item-container").find('a[data-child!="'+ em +'"]').parent().removeClass("active");
  });
});

function newtitle(){
  var currentProductType = text();
  if (currentProductType !== '' && typeof currentProductType !== 'undefined'){
    jQuery_T4NT(".main_title").hide();
    jQuery_T4NT(".main_title").after("<h1 class='collection_title mb__5 cw subtitle'>"+currentProductType+"</h1>");
  } else {
    jQuery_T4NT(".subtitle").remove();
    jQuery_T4NT(".main_title").show();
  }
  return false;
}

function text(){
  var tech = getUrlParameter('q');
  if(tech) {
    var res = tech.split('=');
    var temp = jQuery_T4NT.trim(res[1]);
    var form = temp.split(':');
    var temp2 = jQuery_T4NT.trim(form[0]);
    return temp2.replace('+nt+filter_color','').replace('+nt+filter_size','').replace('+',' ').toLowerCase().replace(/(?<= )[^\s]|^./g, a => a.toUpperCase());
  }
}

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;
  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');
    if (sParameterName[0] === sParam) {
      return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

/* ===================================
   MEMBER PRICE UPDATER - FINAL v10
   =================================== */
(function(jQ) {
  'use strict';

  var DISCOUNT = 0.85;

  function formatMoney(cents) {
    var value = (cents / 100).toFixed(2);
    if (typeof t_moneyFormat !== 'undefined' && t_moneyFormat) {
      return t_moneyFormat
        .replace('{{amount}}', value)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100))
        .replace('{{amount_with_comma_separator}}', value.replace('.', ','))
        .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
    }
    return '$' + value;
  }

  function checkAndUpdate() {
    ['_ppr', '_qv'].forEach(function(cl) {
      var priceEl = document.querySelector('#callBackVariant' + cl + ' .price.price_varies');
      if (!priceEl) return;
      var raw = priceEl.textContent.replace(/[^0-9.]/g, '').trim();
      if (!raw) return;
      var cents = Math.round(parseFloat(raw) * 100);
      if (cents <= 0) return;

      // Update member price block
      var memberCents = Math.round(cents * DISCOUNT);
      var formatted = formatMoney(memberCents);
      jQ('#member-price-value' + cl).text(formatted);
      jQ('#member-price-block' + cl).attr('data-base-price', cents);

      // Mirror the correct variant price to the top price element
      // This keeps the top price in sync since we hid the lower .price_varies
      var topFormatted = formatMoney(cents);
      var $topPrice = jQ('#price' + cl);
      if ($topPrice.length && $topPrice.text().trim() !== topFormatted.trim()) {
        $topPrice.text(topFormatted);
      }
    });
  }

  jQ(document).ready(function() {
    setInterval(checkAndUpdate, 300);
  });

})(jQuery_T4NT);

/* ===================================
   LOGIN CANVAS CLOSE FIX
   =================================== */
jQuery_T4NT(document).on('click', function(e) {
  if (jQuery_T4NT('#nt_login_canvas').hasClass('act_opened')) {
    if (!jQuery_T4NT(e.target).closest('#nt_login_canvas').length &&
        !jQuery_T4NT(e.target).hasClass('member-login-link')) {
      jQuery_T4NT('#nt_login_canvas').removeClass('act_opened').addClass('dn');
      jQuery_T4NT('body').removeClass('pside_opened');
    }
  }
});